export function getRouteState(location, extraState = {}) {
  const from = `${location.pathname || "/"}${location.search || ""}${location.hash || ""}`;
  return { from, ...extraState };
}

export function getRouteBackTarget(location, fallback = "/") {
  return location.state?.from || fallback;
}
